import { createMiddleware } from 'redux-beacon'
import GoogleAnalyticsGtag from '@redux-beacon/google-analytics-gtag'
// module imports
import eventLogger from 'modules/Logger'
import AnalyticsEventsMap from 'modules/Analytics'
// constant imports
import { GA_TRACKING_ID } from 'constants/Analytics'

let middleware

// don't run redux-beacon for localhost
if (process.env?.REACT_APP_LOCAL && !JSON.parse(process.env.REACT_APP_LOCAL)) {
  // create gtag
  const gtag = GoogleAnalyticsGtag(GA_TRACKING_ID)

  // create middleware
  middleware = createMiddleware(AnalyticsEventsMap, gtag, {
    logger: eventLogger.analyticsLogger,
  })
}
const GtagMiddleware = middleware

export default GtagMiddleware
